import React, {useContext} from "react";
import {observer} from "mobx-react";
import {Box} from "../box";
import roomStore from "../../store/roomStore";
import {SpaceContext} from "../../contexts/spaceContext";
import timeStore from "../../store/timeStore";
import numStore from "../../store/numStore";
import {LocStore} from "../../utils";
import 'moment/locale/ko'
import {isMobile} from "react-device-detect";
import _ from "lodash";
import moment from "moment";

const CommonSpaceHeader = observer(() => {
    const reservedTime = LocStore('reservedTime');
    const shopData = roomStore.getShopData() ?? {};
    const timeData = timeStore.getTime() ?? [];
    const ppl = numStore.getNowppl() ?? 0;

    const [state] = useContext(SpaceContext)
    const room = state.filter(item => item['key'] === 'space')[0]['value']
    const date = state.filter(item => item['key'] === 'date')[0]['value']

    const start = timeData?.[0]?.['start'];
    const end = timeData?.[timeData.length - 1]?.['end']

    const et = end?.split(':')[0]
    const em = end?.split(':')[1]
    const st = start?.split(':')[0]
    const sm = start?.split(':')[1]


    const tt1 = Number(st) * 60 + Number(sm)
    const tt2 = Number(et) * 60 + Number(em)
    const diff=  tt2 - tt1;
    const h = Math.floor(diff / 60)
    const l = diff % 60;


    // const totalHour = end?.split(':')[0] - start?.split(':')[0]

    // 시간 문자열 HH:MM을 Date 객체로 변환하는 함수
    function getTimeObject(timeStr) {
        const timeArr = timeStr.split(':');
        const dateObj = new Date();
        dateObj.setHours(timeArr[0]);
        dateObj.setMinutes(timeArr[1]);
        return dateObj;
    }

    function adjustEndTime(startTimeStr, endTimeStr) {
        const startTime = getTimeObject(startTimeStr);
        const endTime = getTimeObject(endTimeStr);
        // 두 시간 차이를 분으로 계산
        const diffMinutes = (endTime.getTime() - startTime.getTime()) / 60000;
        // 차이에 따라 endTime을 조정
        if (diffMinutes >= 30 && diffMinutes < 60) {
            endTime.setMinutes(endTime.getMinutes() - 5);
        }
        else if (diffMinutes >= 60) {
            endTime.setMinutes(endTime.getMinutes() - 10);
        }

        // HH:MM 형식으로 반환
        const adjustedEndTime = endTime.getHours() + ":" + (endTime.getMinutes()<10?'0':'') + endTime.getMinutes();

        return adjustedEndTime;
    }

    const locData = LocStore('userInfo') ?? {};
    const locShopData = LocStore('shopMobileInfo') ?? {};
    const locRoomInfo = LocStore('roomInfo') ?? {};
    const startTime = `${start ?? locData?.['timed']?.['start']}`;
    const endTime = `${end ?? locData?.['timed']?.['end']}`;
    const adjustedEndTime = adjustEndTime(startTime, endTime);
    const resultTime = `${moment(date ?? locData?.['timed']?.['duration'])?.format('yyyy.MM.DD ddd')} ${startTime} ~ ${adjustedEndTime}`;

    return (
        <Box className='reserved_info'>
            <h4>{shopData?.['spName']??locShopData?.['spName']}</h4>
            <dl>
                <dt>{shopData?.['spTitle']??locShopData?.['spTitle']}</dt>
                <dd>{room || locRoomInfo?.['room']?.['stName']}</dd>
                <dd>{reservedTime && reservedTime.reservedTime ? reservedTime.reservedTime : resultTime} / {(isMobile && !_.isNull(LocStore('userInfo'))) ? `${(locData?.['timed']?.['totalHour'] || '').trim()}` : `${h > 0 ? `${h}시간` : ''} ${l > 0 ? `${l}분` : ''}`} / {ppl || locData?.['ppl']}명 </dd>
            </dl>
        </Box>
    )
})

export default CommonSpaceHeader;